import { ComponentPropsWithRef, FC } from 'react';

import { StyledInputSelect } from '@eneco/custom-components/InspirationAdviceFilter';
import { Stack } from '@eneco/sparky';

interface FilterPhraseProps {
  end?: string;
  start?: string;
  ariaLabel?: string;
}

type Props = FilterPhraseProps & ComponentPropsWithRef<typeof StyledInputSelect> & ComponentPropsWithRef<typeof Stack>;

export const FilterPhrase: FC<Props> = ({
  alignX,
  alignY,
  direction,
  end,
  gap,
  isOptional,
  label,
  name,
  onChange,
  options,
  placeholder,
  start,
  ariaLabel,
  value,
}) => (
  <Stack alignX={alignX} alignY={alignY} direction={direction} gap={gap} wrap>
    {start && <Stack.Item>{start}</Stack.Item>}
    <Stack.Item>
      <StyledInputSelect
        isOptional={isOptional}
        label={label}
        name={name}
        onChange={onChange}
        options={options}
        placeholder={placeholder ?? ''}
        data-testid={name}
        value={value}
        aria-label={ariaLabel}
      />
    </Stack.Item>
    {end && <Stack.Item>{end}</Stack.Item>}
  </Stack>
);
